import React from "react";
import { AcceptanceLinkUrls } from "../../../../cores/webForm/utils/formRender.utils";

type LinkPhrase = {
  urlKey: keyof AcceptanceLinkUrls;
  phrases: string[];
};

type PhraseMatch = {
  index: number;
  phrase: string;
  url: string;
};

const LINK_PHRASES: LinkPhrase[] = [
  {
    urlKey: "privacyUrl",
    phrases: [
      "Política de Privacidad y Protección de Datos",
      "Política de Privacidad",
    ],
  },
  {
    urlKey: "termsUrl",
    phrases: ["Términos y Condiciones", "Terminos y Condiciones"],
  },
];

function findEarliestPhraseMatch(
  text: string,
  links: AcceptanceLinkUrls
): PhraseMatch | null {
  let match: PhraseMatch | null = null;

  for (const { urlKey, phrases } of LINK_PHRASES) {
    const url = links[urlKey]?.trim();
    if (!url) continue;

    for (const phrase of phrases) {
      const index = text.indexOf(phrase);
      if (index === -1) continue;
      if (!match || index < match.index) {
        match = { index, phrase, url };
      }
    }
  }

  return match;
}

export function renderAcceptanceLabel(
  label: string,
  links: AcceptanceLinkUrls
): React.ReactNode {
  const nodes: React.ReactNode[] = [];
  let remaining = label;
  let key = 0;

  while (remaining.length > 0) {
    const match = findEarliestPhraseMatch(remaining, links);

    if (!match) {
      nodes.push(remaining);
      break;
    }

    if (match.index > 0) {
      nodes.push(remaining.slice(0, match.index));
    }

    nodes.push(
      <a
        key={`acceptance-link-${key}`}
        href={match.url}
        target="_blank"
        rel="noopener noreferrer"
        className="web-form-fields__check-link"
        onClick={(event) => event.stopPropagation()}
      >
        {match.phrase}
      </a>
    );
    key += 1;
    remaining = remaining.slice(match.index + match.phrase.length);
  }

  return nodes;
}
